import NewByOwnerChart from './NewByOwnerChart.container';

export default NewByOwnerChart;
